   const classesSearchDrawer = {
      open: 'is-open',
      closing: 'is-closing',
      duplicate: 'drawer--duplicate',
      drawerEditorError: 'drawer-editor-error',
    };

    const selectorsSearchDrawer = {
      searchDrawer: 'search-drawer',
      searchDrawerClose: '[data-search-drawer-close]',
      searchDrawerSection: '[data-section-type="search-drawer"]',
      searchDrawerInner: '[data-search-drawer-inner]',
      shopifySection: '.shopify-section',
    };

    const attributesSearchDrawer = {
      drawerUnderlay: 'data-drawer-underlay',
    };

    class SearchDrawer extends HTMLElement {
      constructor() {
        super();

        this.searchDrawerIsOpen = false;

        this.searchDrawerClose = this.querySelector(selectorsSearchDrawer.searchDrawerClose);
        this.searchDrawerInner = this.querySelector(selectorsSearchDrawer.searchDrawerInner);
        this.opensearchDrawer = this.opensearchDrawer.bind(this);
        this.closesearchDrawer = this.closesearchDrawer.bind(this);
        this.togglesearchDrawer = this.togglesearchDrawer.bind(this);
        this.opensearchDrawerOnSelect = this.opensearchDrawerOnSelect.bind(this);
        this.closesearchDrawerOnDeselect = this.closesearchDrawerOnDeselect.bind(this);
        this.searchDrawerSection = this.closest(selectorsSearchDrawer.shopifySection);
        this.a11y = window.theme.a11y;

        this.closeSearchDrawerEvents();
      }

      connectedCallback() {
        const drawerSection = this.closest(selectorsSearchDrawer.shopifySection);

        /* Prevent duplicated cart drawers */
        if (window.theme.hassearchDrawer) {
          if (!window.Shopify.designMode) {
            drawerSection.remove();
            return;
          } else {
            const errorMessage = document.createElement('div');
            errorMessage.classList.add(classesSearchDrawer.drawerEditorError);
            errorMessage.innerText = 'Cart drawer section already exists.';

            if (!this.querySelector(`.${classesSearchDrawer.drawerEditorError}`)) {
              this.querySelector(selectorsSearchDrawer.searchDrawerInner).append(errorMessage);
            }

            this.classList.add(classesSearchDrawer.duplicate);
          }
        }

        window.theme.hassearchDrawer = true;

        this.addEventListener('theme:search-drawer:show', this.opensearchDrawer);
        document.addEventListener('theme:search-drawer:toggle', this.togglesearchDrawer);
        document.addEventListener('shopify:block:select', this.opensearchDrawerOnSelect);
        document.addEventListener('shopify:section:select', this.opensearchDrawerOnSelect);
        document.addEventListener('shopify:section:deselect', this.closesearchDrawerOnDeselect);
      }

      disconnectedCallback() {
        document.removeEventListener('theme:search-drawer:toggle', this.togglesearchDrawer);
        document.removeEventListener('shopify:block:select', this.opensearchDrawerOnSelect);
        document.removeEventListener('shopify:section:select', this.opensearchDrawerOnSelect);
        document.removeEventListener('shopify:section:deselect', this.closesearchDrawerOnDeselect);

        if (document.querySelectorAll(selectorsSearchDrawer.searchDrawer).length <= 1) {
          window.theme.hassearchDrawer = false;
        }
      }

      /**
       * Open cart drawer on block or section select
       *
       * @return  {Void}
       */
      opensearchDrawerOnSelect(e) {
        const searchDrawerSection = e.target.querySelector(selectorsSearchDrawer.shopifySection) || e.target.closest(selectorsSearchDrawer.shopifySection) || e.target;

        if (searchDrawerSection === this.searchDrawerSection) {
          this.opensearchDrawer(true);
        }
      }

      /**
       * Close cart drawer on section deselect
       *
       * @return  {Void}
       */
      closesearchDrawerOnDeselect() {
        if (this.searchDrawerIsOpen) {
          this.closesearchDrawer();
        }
      }

      /**
       * Open cart drawer and add class on body
       *
       * @return  {Void}
       */

      opensearchDrawer(forceOpen = false) {
        if (!forceOpen && this.classList.contains(classesSearchDrawer.duplicate)) return;

        this.searchDrawerIsOpen = true;
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        document.body.addEventListener('click', this.onBodyClickEvent);

        document.dispatchEvent(
          new CustomEvent('theme:search-drawer:open', {
            detail: {
              target: this,
            },
            bubbles: true,
          })
        );
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));

        this.classList.add(classesSearchDrawer.open);

        window.theme.waitForAnimationEnd(this.searchDrawerInner).then(() => {
          this.a11y.trapFocus(this, {
            elementToFocus: this.querySelector(selectorsSearchDrawer.searchDrawerClose),
          });
        });
      }

      /**
       * Close cart drawer and remove class on body
       *
       * @return  {Void}
       */

      closesearchDrawer() {
        if (!this.classList.contains(classesSearchDrawer.open)) return;

        this.classList.add(classesSearchDrawer.closing);
        this.classList.remove(classesSearchDrawer.open);

        this.searchDrawerIsOpen = false;

        document.dispatchEvent(
          new CustomEvent('theme:search-drawer:close', {
            bubbles: true,
          })
        );

        this.a11y.removeTrapFocus();
        this.a11y.autoFocusLastElement();

        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

        window.theme.waitForAnimationEnd(this.searchDrawerInner).then(() => {
          this.classList.remove(classesSearchDrawer.closing);
        });
      }

      /**
       * Toggle cart drawer
       *
       * @return  {Void}
       */

      togglesearchDrawer() {
        if (!this.searchDrawerIsOpen) {
          this.opensearchDrawer();
        } else {
          this.closesearchDrawer();
        }
      }

      /**
       * Event click to element to close cart drawer
       *
       * @return  {Void}
       */

      closeSearchDrawerEvents() {
        this.searchDrawerClose.addEventListener('click', (e) => {
          e.preventDefault();
          this.closesearchDrawer();
        });

        this.addEventListener('keyup', (e) => {
          if (e.code === 'Escape') {
            this.closesearchDrawer();
          }
        });
      }

      onBodyClick(e) {
        if (e.target.hasAttribute(attributesSearchDrawer.drawerUnderlay)) this.closesearchDrawer();
      }
    }

    if (!customElements.get('search-drawer')) {
      customElements.define('search-drawer', SearchDrawer);
    }


      const selectorsHeaderSearch = {
      inputSearch: 'input[type="search"]',
      focusedElements: '[aria-selected="true"] a',
      resetButton: 'button[type="reset"]',
    };

    const classesHeaderSearch = {
      hidden: 'hidden',
    };

    class HeaderSearchForm extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector(selectorsHeaderSearch.inputSearch);
        this.resetButton = this.querySelector(selectorsHeaderSearch.resetButton);

        if (this.input) {
          this.input.form.addEventListener('reset', this.onFormReset.bind(this));
          this.input.addEventListener(
            'input',
            window.theme
              .debounce((event) => {
                this.onChange(event);
              }, 300)
              .bind(this)
          );
        }
      }

      toggleResetButton() {
        const resetIsHidden = this.resetButton.classList.contains(classesHeaderSearch.hidden);
        if (this.input.value.length > 0 && resetIsHidden) {
          this.resetButton.classList.remove(classesHeaderSearch.hidden);
        } else if (this.input.value.length === 0 && !resetIsHidden) {
          this.resetButton.classList.add(classesHeaderSearch.hidden);
        }
      }

      onChange() {
        this.toggleResetButton();
      }

      shouldResetForm() {
        return !document.querySelector(selectorsHeaderSearch.focusedElements);
      }

      onFormReset(event) {
        // Prevent default so the form reset doesn't set the value gotten from the url on page load
        event.preventDefault();
        // Don't reset if the user has selected an element on the predictive search dropdown
        if (this.shouldResetForm()) {
          this.input.value = '';
          this.toggleResetButton();
          event.target.querySelector(selectorsHeaderSearch.inputSearch).focus();
        }
      }
    }

      const selectorsPredictiveDrawer = {
      allVisibleElements: '[role="option"]',
      ariaSelected: '[aria-selected="true"]',
      popularSearches: '[data-popular-searches]',
      predictiveSearch: 'predictive-search',
      predictiveSearchResults: '[data-predictive-search-results]',
      predictiveSearchStatus: '[data-predictive-search-status]',
      searchInput: 'input[type="search"]',
      searchPopdown: '[data-popdown]',
      searchResultsLiveRegion: '[data-predictive-search-live-region-count-value]',
      searchResultsGroupsWrapper: '[data-search-results-groups-wrapper]',
      searchForText: '[data-predictive-search-search-for-text]',
      sectionPredictiveSearch: '#shopify-section-predictive-search-drawer',
      selectedLink: '[aria-selected="true"] a',
      selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
    };

    if (!customElements.get('predictive-search-drawer')) {
      customElements.define(
        'predictive-search-drawer',

        class PredictiveSearchDrawer extends HeaderSearchForm {
          constructor() {
            super();

            this.a11y = window.theme.a11y;
            this.abortController = new AbortController();
            this.allPredictiveSearchInstances = document.querySelectorAll(selectorsPredictiveDrawer.predictiveSearch);
            this.cachedResults = {};
            this.input = this.querySelector(selectorsPredictiveDrawer.searchInput);
            this.isOpen = false;
            this.predictiveSearchResults = this.querySelector(selectorsPredictiveDrawer.predictiveSearchResults);
            this.searchPopdown = this.closest(selectorsPredictiveDrawer.searchPopdown);
            this.popularSearches = this.searchPopdown?.querySelector(selectorsPredictiveDrawer.popularSearches);
            this.searchTerm = '';
          }

          connectedCallback() {
            this.input.addEventListener('focus', this.onFocus.bind(this));
            this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

            this.addEventListener('focusout', this.onFocusOut.bind(this));
            this.addEventListener('keyup', this.onKeyup.bind(this));
            this.addEventListener('keydown', this.onKeydown.bind(this));
          }

          getQuery() {
            return this.input.value.trim();
          }

          onChange() {
            super.onChange();
            const newSearchTerm = this.getQuery();

            if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
              // Remove the results when they are no longer relevant for the new search term
              // so they don't show up when the dropdown opens again
              this.querySelector(selectorsPredictiveDrawer.searchResultsGroupsWrapper)?.remove();
            }

            // Update the term asap, don't wait for the predictive search query to finish loading
            this.updateSearchForTerm(this.searchTerm, newSearchTerm);

            this.searchTerm = newSearchTerm;

            if (!this.searchTerm.length) {
              this.reset();
              return;
            }

            this.getSearchResults(this.searchTerm);
          }

          onFormSubmit(event) {
            if (!this.getQuery().length || this.querySelector(selectorsPredictiveDrawer.selectedLink)) event.preventDefault();
          }

          onFormReset(event) {
            super.onFormReset(event);
            if (super.shouldResetForm()) {
              this.searchTerm = '';
              this.abortController.abort();
              this.abortController = new AbortController();
              this.closeResults(true);
            }
          }

          shouldResetForm() {
            return !document.querySelector(selectorsPredictiveDrawer.selectedLink);
          }

          onFocus() {
            const currentSearchTerm = this.getQuery();

            if (!currentSearchTerm.length) return;

            if (this.searchTerm !== currentSearchTerm) {
              // Search term was changed from other search input, treat it as a user change
              this.onChange();
            } else if (this.getAttribute('results') === 'true') {
              this.open();
            } else {
              this.getSearchResults(this.searchTerm);
            }
          }

          onFocusOut() {
            setTimeout(() => {
              if (!this.contains(document.activeElement)) this.close();
            });
          }

          onKeyup(event) {
            if (!this.getQuery().length) this.close(true);
            event.preventDefault();

            switch (event.code) {
              case 'ArrowUp':
                this.switchOption('up');
                break;
              case 'ArrowDown':
                this.switchOption('down');
                break;
              case 'Enter':
                this.selectOption();
                break;
            }
          }

          onKeydown(event) {
            // Prevent the cursor from moving in the input when using the up and down arrow keys
            if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
              event.preventDefault();
            }
          }

          updateSearchForTerm(previousTerm, newTerm) {
            const searchForTextElement = this.querySelector(selectorsPredictiveDrawer.searchForText);
            const currentButtonText = searchForTextElement?.innerText;

            if (currentButtonText) {
              if (currentButtonText.match(new RegExp(previousTerm, 'g'))?.length > 1) {
                // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
                return;
              }
              const newButtonText = currentButtonText.replace(previousTerm, newTerm);
              searchForTextElement.innerText = newButtonText;
            }
          }

          switchOption(direction) {
            if (!this.getAttribute('open')) return;

            const moveUp = direction === 'up';
            const selectedElement = this.querySelector(selectorsPredictiveDrawer.ariaSelected);

            // Filter out hidden elements (duplicated page and article resources) thanks
            // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
            const allVisibleElements = Array.from(this.querySelectorAll(selectorsPredictiveDrawer.allVisibleElements)).filter((element) => element.offsetParent !== null);

            let activeElementIndex = 0;

            if (moveUp && !selectedElement) return;

            let selectedElementIndex = -1;
            let i = 0;

            while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
              if (allVisibleElements[i] === selectedElement) {
                selectedElementIndex = i;
              }
              i++;
            }

            this.statusElement.textContent = '';

            if (!moveUp && selectedElement) {
              activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
            } else if (moveUp) {
              activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
            }

            if (activeElementIndex === selectedElementIndex) return;

            const activeElement = allVisibleElements[activeElementIndex];

            activeElement.setAttribute('aria-selected', true);
            if (selectedElement) selectedElement.setAttribute('aria-selected', false);

            this.input.setAttribute('aria-activedescendant', activeElement.id);
          }

          selectOption() {
            const selectedOption = this.querySelector(selectorsPredictiveDrawer.selectedOption);

            if (selectedOption) selectedOption.click();
          }

          getSearchResults(searchTerm) {
            const queryKey = searchTerm.replace(' ', '-').toLowerCase();
            this.setLiveRegionLoadingState();

            if (this.cachedResults[queryKey]) {
              this.renderSearchResults(this.cachedResults[queryKey]);
              return;
            }

            fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search-drawer`, {signal: this.abortController.signal})
              .then((response) => {
                if (!response.ok) {
                  var error = new Error(response.status);
                  this.close();
                  throw error;
                }

                return response.text();
              })
              .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector(selectorsPredictiveDrawer.sectionPredictiveSearch).innerHTML;
                // Save bandwidth keeping the cache in all instances synced
                this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
                  predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
                });
                this.renderSearchResults(resultsMarkup);
              })
              .catch((error) => {
                if (error?.code === 20) {
                  // Code 20 means the call was aborted
                  return;
                }
                this.close();
                throw error;
              });
          }

          setLiveRegionLoadingState() {
            this.statusElement = this.statusElement || this.querySelector(selectorsPredictiveDrawer.predictiveSearchStatus);
            this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

            this.setLiveRegionText(this.loadingText);
            this.setAttribute('loading', true);
          }

          setLiveRegionText(statusText) {
            this.statusElement.setAttribute('aria-hidden', 'false');
            this.statusElement.textContent = statusText;

            setTimeout(() => {
              this.statusElement.setAttribute('aria-hidden', 'true');
            }, 1000);
          }

          renderSearchResults(resultsMarkup) {
            this.predictiveSearchResults.innerHTML = resultsMarkup;

            this.setAttribute('results', true);

            this.setLiveRegionResults();
            this.open();
          }

          setLiveRegionResults() {
            this.removeAttribute('loading');
            this.setLiveRegionText(this.querySelector(selectorsPredictiveDrawer.searchResultsLiveRegion).textContent);
          }

          open() {
            this.setAttribute('open', true);
            this.input.setAttribute('aria-expanded', true);
            this.isOpen = true;
            this.predictiveSearchResults.style.setProperty('--results-height', `${window.visualViewport.height - this.predictiveSearchResults.getBoundingClientRect().top}px`);
          }

          close(clearSearchTerm = false) {
            this.closeResults(clearSearchTerm);
            this.isOpen = false;
            this.predictiveSearchResults.style.removeProperty('--results-height');
          }

          closeResults(clearSearchTerm = false) {
            if (clearSearchTerm) {
              this.input.value = '';
              this.removeAttribute('results');
            }
            const selected = this.querySelector(selectorsPredictiveDrawer.ariaSelected);

            if (selected) selected.setAttribute('aria-selected', false);

            this.input.setAttribute('aria-activedescendant', '');
            this.removeAttribute('loading');
            this.removeAttribute('open');
            this.input.setAttribute('aria-expanded', false);
            this.predictiveSearchResults?.removeAttribute('style');
          }

          reset() {
            this.predictiveSearchResults.innerHTML = '';

            this.input.val = '';
            this.a11y.removeTrapFocus();

            if (this.popularSearches) {
              this.input.dispatchEvent(new Event('blur', {bubbles: false}));
              this.a11y.trapFocus(this.searchPopdown, {
                elementToFocus: this.input,
              });
            }
          }
        }
      );
    }

    document.querySelectorAll(".search-drawer-button")?.forEach(searchButton => {

        searchButton.addEventListener("click", function(e) {
            document.querySelector("search-drawer").opensearchDrawer();
        });
    });

//   !function() {
//   "use strict";
//   const t = "search-related-products"
//     , e = "data-url";
//   class SearchUpsellProducts extends HTMLElement {
//       constructor() {
//           super()
//       }
//       connectedCallback() {
//           this.loadRecommendations();
//           //console.log("search-related-products connectedCallback ", this.getAttribute(e))
//       }
//       loadRecommendations() {

//           fetch(this.getAttribute(e)).then((t => t.text())).then((e => {
//                   const s = document.createElement("div");
//                   s.innerHTML = e;
//                   const r = s.querySelector(t);

//                   r && r.innerHTML.trim().length && (this.innerHTML = r.innerHTML
//                   )
//               }
//               )).catch((t => {
//                   console.error(t)
//               }
//               ))
//       }
//   }
//   customElements.get("search-related-products") || customElements.define("search-related-products", SearchUpsellProducts);
// }();